import { render } from "./AppPagination.vue?vue&type=template&id=7f9b72ac&scoped=true"
import script from "./AppPagination.vue?vue&type=script&lang=js"
export * from "./AppPagination.vue?vue&type=script&lang=js"

import "./AppPagination.vue?vue&type=style&index=0&id=7f9b72ac&lang=scss&scoped=true"
import "./AppPagination.vue?vue&type=style&index=1&id=7f9b72ac&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9b72ac"]])

export default __exports__